import { z } from "zod";

const DeleteRoomMaintenanceResponse = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.null(),
});

export { DeleteRoomMaintenanceResponse };
export type DeleteRoomMaintenanceResponseType = z.infer<typeof DeleteRoomMaintenanceResponse>;